import React, { useEffect, useState } from "react";
import "./Navigation.css";
import { Grid, Modal, Paper, Typography } from "@mui/material";
import { withRouter, useLocation, useParams } from "react-router-dom";
import { getClientAndCoClient } from "../../api/advisor/client";
import { calculatePlan } from "../../api/advisor/plans";
import { connect } from "react-redux";
import * as actionTypes from "../../redux/constants";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import AddAClientModal from "../../components/Modals/AddAClientModal/AddAClientModal";
import SecondaryNavigation from "@instream-solutions/instream-design-system/lib/UX/SecondaryNavigation/SecondaryNavigation";
import {
  getAge,
  tracateContent,
  translateRelationshipType,
} from "../../common/shared";
import Header from "@instream-solutions/instream-design-system/lib/Components/Header/Header";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Loader from "../../components/Utility/Loader/Loader";
import ConfirmationDialog from "@instream-solutions/instream-design-system/lib/UX/ConfirmationDialog/ConfirmationDialog";
import MaterialTooltip from "@mui/material/Tooltip";
import Button from "@instream-solutions/instream-design-system/lib/UX/Button/Button";
import PlanCreationModal from "../../components/Modals/PlanCreationModal/PlanCreationModal";
import { MARK_PLAN_LIST_INVALID } from "../../redux/constants";

const Wrapper = styled(Paper)`
  padding: 0px;
  padding-left: 7px;
`;

const Navigation = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [state, setState] = useState({
    isClientPanelExpanded: false,
    isPlanCreationModalOpen: false,
    showAddAClientModal: false,
    tabIndex: props.history.location.pathname.includes("/profile") ? 0 : 1,
    openCancelCreatePlanModal: false,
    openCancelCreatePlanModalPath: null,
  });

  const { id } = useParams();

  const { t } = useTranslation();

  let cancelCreatePlanModal;
  if (state.openCancelCreatePlanModal) {
    cancelCreatePlanModal = (
      <ConfirmationDialog
        title={"Confirmation"}
        message={
          "You are in the middle of creating a plan. Plan inputs will not be saved if you leave."
        }
        cancelLabel={"Cancel"}
        confirmLabel={"Continue"}
        onCancel={() => {
          setState({
            ...state,
            openCancelCreatePlanModal: false,
            openCancelCreatePlanModalPath: null,
          });
        }}
        onConfirm={() => {
          const path = state.openCancelCreatePlanModalPath;
          setState({
            ...state,
            openCancelCreatePlanModal: false,
            openCancelCreatePlanModalPath: null,
          });
          props.history.push(path);
        }}
      />
    );
  }

  useEffect(() => {
    if (window.location.href.includes("/profile")) {
      setState({
        ...state,
        tabIndex: 0,
      });
      return;
    }
    if (window.location.href.includes("/scenarios")) {
      setState({
        ...state,
        tabIndex: 2,
      });
      return;
    }
    setState({
      ...state,
      tabIndex: 1,
    });
  }, [window.location.href]);

  useEffect(() => {
    if (!props.useHeader) return;

    const currentAdvisor = props.currentUser.toJS();
    const currentClient = props.currentClient.toJS();

    if (currentClient.client.id !== parseInt(id)) {
      setIsLoading(true);

      getClientAndCoClient(currentAdvisor.advisor.advisorId, id).then(
        (response) => {
          response.client.relationshipType = translateRelationshipType(
            response.client.relationshipType,
            t
          );
          props.setCurrentClient(response.client);
          response.coClient.relationshipType = translateRelationshipType(
            response.coClient.relationshipType,
            t
          );
          props.setCurrentCoClient(response.coClient);
          response.family.map((member) => {
            member.relationshipType = translateRelationshipType(
              member.relationshipType,
              t
            );
            return member;
          });
          props.setCurrentFamily(response.family);
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        }
      );
    } else {
      setIsLoading(false);
    }
  }, []);

  const generateTree = (routes) => {
    const getPath = (r) => {
      if (r.children && r.children.length > 0) {
        return r.children[0].path;
      }

      return r.path;
    };

    let currentLocation = props.history.location.pathname;

    return routes
      .filter((r) => {
        return !r.hide;
      })
      .map((r) => {
        let path = r.path.split(":id")[1];

        return {
          label: r.name,
          expanded: currentLocation.includes(path),
          url: getPath(r),
          items: r.children
            ? r.children
                .filter((c) => !c.hide)
                .map((child) => {
                  let innerPath = child.path.split(":id")[1];

                  return {
                    label: child.name,
                    url: child.path,
                    selected: innerPath
                      ? currentLocation.includes(innerPath)
                      : currentLocation.includes(child.path),
                  };
                })
            : [],
        };
      });
  };

  const tree = generateTree(props.navItems);

  const onItemClick = (item) => {
    if (!item.url) return;
    props.history.push(item.url.replace(":id", id));
  };

  const closeCreateAClientModal = () => {
    setState({
      ...state,
      showAddAClientModal: false,
    });
  };

  const saveAndCloseCreateAClientModal = (client, coClient) => {
    closeCreateAClientModal();
    client.relationshipType = {
      id: "CLIENT",
      name: t("ClientDetails.Profile.Family.Relationship.client"),
    };
    props.updateClient(client);
    if (coClient != null) {
      coClient.relationshipType = {
        id: "COCLIENT",
        name: t("ClientDetails.Profile.Family.Relationship.co_client"),
      };
      props.updateCoClient(coClient);
    }
  };

  const getClientEmail = () => {
    if (client.emailList.length === 0) return "";
    return `${client.emailList[0].emailAddress}`;
  };

  const getClientPhone = () => {
    if (client.phoneList.length === 0) return "";
    return `${client.phoneList[0].phoneNumber}`;
  };

  const client = props.currentClient.get("client").toJS();

  const location = useLocation();
  let createPlanBtn;
  if (location.pathname.includes("/plans/wizard")) {
    createPlanBtn = (
      <Button
        label={t("ClientDetails.Client.cancel_create_plan")}
        primary={false}
        outline={true}
        onClick={() => {
          setState({
            ...state,
            openCancelCreatePlanModal: true,
            openCancelCreatePlanModalPath: props.topNavItems[1].path.replace(
              ":id",
              id
            ),
          });
        }}
        className="cancel-new-plan-btn"
      />
    );
  } else {
    createPlanBtn = (
      <Button
        label={t("ClientDetails.Client.create_plan")}
        icon="plus"
        primary={true}
        outline={false}
        onClick={() => {
          props.openPlanCreationModal();
        }}
        className="create-new-plan-btn"
      />
    );
  }

  const minimizedClientHeader = (
    <Grid xs={8} className={"minimized-top-bar"}>
      <Typography variant={"h1"} component={"h1"}>
        {tracateContent(client.firstName + " " + client.lastName, 40) +
          " (" +
          getAge(client.dateOfBirth) +
          ")"}
      </Typography>
    </Grid>
  );

  const clientHeader = client.id ? (
    <Grid className={"client-top-bar"} item xs={12}>
      <Header
        title={
          tracateContent(client.firstName + " " + client.lastName, 40) +
          " (" +
          getAge(client.dateOfBirth) +
          ")"
        }
        color={"primary"}
      >
        {createPlanBtn}
      </Header>
      {cancelCreatePlanModal}
    </Grid>
  ) : (
    <Grid className={"client-top-bar"} item xs={12}>
      <Loader />
    </Grid>
  );

  let emailContent;
  if (getClientEmail().length > 50) {
    emailContent = (
      <MaterialTooltip title={getClientEmail()} placement="top" arrow>
        <div className="email-content">
          <a href={"mailto:" + getClientEmail()}>
            {getClientEmail().substring(0, 17) + "..."}
          </a>
        </div>
      </MaterialTooltip>
    );
  } else {
    emailContent = (
      <div className="email-content">
        <a href={"mailto:" + getClientEmail()}>{getClientEmail()}</a>
      </div>
    );
  }

  const clientInformationBar = client.id ? (
    <React.Fragment>
      <Grid item xs={2} className="info-cell">
        <label className="title">Date of Birth</label>
        <div className="content">{client.dateOfBirth}</div>
      </Grid>
      <Grid item xs={2} className="info-cell">
        <label className="title">Phone</label>
        <div className="content">{getClientPhone()}</div>
      </Grid>
      <Grid item xs={4} className="info-cell">
        <label className="title">Email</label>
        {emailContent}
      </Grid>
    </React.Fragment>
  ) : (
    <Grid item xs={8} className="info-bar-loading">
      <Loader />
    </Grid>
  );

  const addAClientModal = state.showAddAClientModal ? (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={"detail-creation-modal"}
      disableEnforceFocus={true}
      open={true}
      close={closeCreateAClientModal}
    >
      <div
        style={{
          top: "10%",
          left: "20%",
          position: "absolute",
          width: "60%",
          border: "2px solid #000",
          padding: "8px 16px 12px",
          boxShadow: "0 0 14px 0 rgba(53,64,82,.05)",
          backgroundColor: "#fff",
        }}
      >
        <AddAClientModal
          save={saveAndCloseCreateAClientModal}
          close={closeCreateAClientModal}
          client={props.currentClient.get("client").toJS()}
          coClient={props.currentClient.get("coClient").toJS()}
        />
      </div>
    </Modal>
  ) : null;

  let content = (
    <Grid item xs={12}>
      {props.children}
    </Grid>
  );

  const navItems = props.navItems.filter((nav) => !nav.hide);
  if (navItems.length > 0) {
    content = (
      <React.Fragment>
        <Grid item xs={12}>
          <div className={"navigation-layout-side"}>
            {tree.map((top) => (
              <SecondaryNavigation
                header={top.label}
                options={top.items}
                onClick={onItemClick}
              />
            ))}
          </div>
          <div className={"navigation-layout-content"}>{props.children}</div>
        </Grid>
      </React.Fragment>
    );
  }

  const onClickTabBtn = (tabIndex) => {
    if (location.pathname.endsWith("/newplan")) {
      setState({
        ...state,
        openCancelCreatePlanModal: true,
        openCancelCreatePlanModalPath: props.topNavItems[tabIndex].path.replace(
          ":id",
          id
        ),
      });
    } else {
      setState({
        ...state,
        tabIndex: tabIndex,
      });
      props.history.push({
        pathname: props.topNavItems[tabIndex].path.replace(":id", id),
        tabIndex: tabIndex,
      });
    }
  };

  return (
    <Wrapper className={"navigation-content-container"}>
      <Grid container spacing={3}>
        {!props.useHeader && (
          <Grid className={"client-top-bar"} item xs={12}>
            <Typography variant={"h1"} component={"h1"}>
              {props.topNavItems[0].headerName}
            </Typography>
          </Grid>
        )}
        {props.useHeader && props.minimizeHeader && minimizedClientHeader}
        {props.useHeader && !props.minimizeHeader && clientHeader}
        {props.useHeader && !props.minimizeHeader && clientInformationBar}
        {props.useHeader && (
          <Grid className={"navigation-layout-top"} item xs={4}>
            <div className="tab-navigation">
              <Tabs
                value={state.tabIndex}
                indicatorColor="primary"
                textColor="primary"
                onChange={(event, tabIndex) => onClickTabBtn(tabIndex)}
              >
                <Tab label={"PROFILE"} />
                <Tab label={"PLANS"} />
                <Tab label={"SCENARIOS"} />
              </Tabs>
            </div>
          </Grid>
        )}
        <div className={"navigation-layout-wrapper"}>
          {content}
          {addAClientModal}
        </div>
        {props.isPlanCreationModalOpen && !isLoading && (
          <PlanCreationModal
            open={props.isPlanCreationModalOpen}
            onClose={() => {
              props.markPlanListInvalid();
              props.closePlanCreationModal();
            }}
            onSavePlan={(planId) => {
              const currentUser = props.currentUser.toJS();
              const currentClient = props.currentClient.toJS();
              const advisorId = currentUser.advisor.advisorId;
              const clientId = currentClient.client.id;

              calculatePlan(advisorId, clientId, planId).then(() => {
                props.closePlanCreationModal();
                props.markPlanListInvalid();

                props.history.push(
                  `/advisor/clients/details/${clientId}/plans/details/${planId}`
                );
              });
            }}
          />
        )}
      </Grid>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUserReducer,
    currentClient: state.currentClientReducer,
    isPlanCreationModalOpen: state.uxStateReducer.get(
      "isPlanCreationModalOpen"
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentClient: (data) =>
      dispatch({
        type: actionTypes.SET_CURRENT_CLIENT,
        data: data,
      }),
    setCurrentCoClient: (data) =>
      dispatch({
        type: actionTypes.SET_CURRENT_COCLIENT,
        data: data,
      }),
    setCurrentFamily: (data) =>
      dispatch({
        type: actionTypes.SET_CURRENT_FAMILY,
        data: data,
      }),
    updateClient: (client) =>
      dispatch({
        type: actionTypes.SET_CURRENT_CLIENT,
        data: client,
      }),
    updateCoClient: (coClient) =>
      dispatch({
        type: actionTypes.SET_CURRENT_COCLIENT,
        data: coClient,
      }),
    openPlanCreationModal: () =>
      dispatch({
        type: actionTypes.SHOW_PLAN_CREATION_MODAL,
        value: null,
      }),
    closePlanCreationModal: () =>
      dispatch({
        type: actionTypes.HIDE_PLAN_CREATION_MODAL,
      }),
    markPlanListInvalid: () =>
      dispatch({
        type: actionTypes.MARK_PLAN_LIST_INVALID,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Navigation));
